import * as React from 'react'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import {
  NavItem,
  navItemTileStyle,
  navItemTextStyle,
  navIconSize,
  NavTooltip,
} from '@user/components/App/SideNav'
import MapIcon from '@mui/icons-material/Map'

type Props = {
  onClick?: () => void
  expanded: boolean
}

export function MapViewButton(props: Props) {
  const { onClick, expanded } = props

  return (
    <NavTooltip label="Map View" expanded={expanded}>
      <NavItem
        onClick={onClick}
        data-test-id="mapViewIcon"
        style={{ ...navItemTileStyle, flexGrow: 0, padding: 0 }}
      >
        <Box width={navIconSize} height={navIconSize} margin="0px 8px 0px 5px">
          <MapIcon sx={{ width: navIconSize, height: navIconSize }} />
        </Box>
        <Typography sx={navItemTextStyle}>Map View</Typography>
      </NavItem>
    </NavTooltip>
  )
}
